import { default as utils } from "./utils.min.js";

$(function () {
	// SHOW: Right Panels (Login, Accounts, Resources)
	$(".ft-header").on("click", ".nav-items a.nav-popover", function (e) {
		e.preventDefault();

		const $this = $(this);

		// Hide all right panel
		$(".ft-header-panel .header-panel").removeClass("show");

		let navItem = $this.attr("href");
		navItem = navItem.replace("#", "");

		// Highlight all items based selected category
		$(".ft-bg-overlay").addClass("show");
		$("body").addClass("overflow-hidden");

		// Show for the specific navItem
		$(`#ft-${navItem}-nav`).children(".header-panel").addClass("show");

		// for Mobile
		$(".ft-header").removeClass("show");
	});

	$("body").on("click", ".account-button-trigger", function (e){
		e.preventDefault();

		$('a.nav-popover').trigger('click');
	});

	// HIDE: Right Panels (Login, Accounts, Resources)
	$("body").on("click", ".ft-bg-overlay", function (e) {
		e.preventDefault();

		$(".ft-header").removeClass("show");
		$(".ft-header-panel .header-panel").removeClass("show");
		$(".ft-bg-overlay").removeClass("show");
		$("body").removeClass("overflow-hidden");
	});

	// Fixed header subNav
	$(window).on("scroll", function () {
		const scroll = $(window).scrollTop();

		// print "false" if direction is down and "true" if up
		$("header.ft-header").toggleClass("hide", this.oldScroll < this.scrollY);
		$(".ft-subNav").toggleClass("hide", this.oldScroll < this.scrollY);

		if (scroll <= 80) {
			$("header.ft-header").removeClass("hide");
			$(".ft-subNav").removeClass("hide");
		}

		this.oldScroll = this.scrollY;
	});

	// Mobile: Mobile Nav
	$(".mobile-menu-button").on("click", function () {
		var $this = $(this);

		$(".ft-header-panel .header-panel").removeClass("show");
		// for Desktop
		$(".ft-bg-overlay").removeClass("show");

		$("body").toggleClass("overflow-hidden");
		$("#mobile-menu").parents(".ft-header").toggleClass("show");
	});

	// Select2 Open
	$(document).on("select2:open", function () {
		document.querySelector(".select2-search__field").focus();
	});

	// Hide - Right Panel
	$("body").on("click", ".ft-bg-overlay, .aside-right-panel .btn-close", function (e) {
		e.preventDefault();

		const $asidePanel = $(".aside-right-panel .header-panel");
		const $FTOverlay = $(".ft-bg-overlay");

		// Hide right panel detail
		$asidePanel.removeClass("show");
		$FTOverlay.removeClass("show");
		$("body").removeClass("overflow-hidden");
	});

	// Collapsible
	$(".ft-collapse").on("click", ".collapse-group:not(.collapse-nested) > .collapse-bar", function (e) {
		e.preventDefault();

		const $thisParent = $(this).parent(".collapse-group");

		if ($thisParent.hasClass("collapsed")) {
			$thisParent.removeClass("collapsed");
		} else {
			$thisParent.addClass("collapsed");
		}

		$(".collapse-bar").not(this).parent(".collapse-group").removeClass("collapsed");
	});

	// Collapsible - Nested
	$(".collapse-details .ft-collapse").on("click", ".collapse-nested > .collapse-bar", function (e) {
		e.preventDefault();

		const $thisParent = $(this).parent(".collapse-nested");

		if ($thisParent.hasClass("collapsed")) {
			$thisParent.removeClass("collapsed");
		} else {
			$thisParent.addClass("collapsed");
		}

		$(".collapse-bar").not(this).parent(".collapse-nested").removeClass("collapsed");
	});

	// Show: Play Video
	$(".ft-btn-play").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		const embeded = $this.attr("data-embeded");
		const videoUrl = $this.attr("data-videoUrl");
		const posterUrl = $this.attr("data-posterUrl");

		// Video
		const videoHTML = `<video controls autoplay loop muted poster="${posterUrl}">
				<source src="${videoUrl}" type="video/mp4" />
				Your browser does not support the video tag.
			</video>`;

		// Embeded Vimeo
		const embededHTML = `<iframe src="${videoUrl}?autoplay=1" frameborder="0" width="100%" height="410px" allow="autoplay" allowfullscreen></iframe><script src="https://player.vimeo.com/api/player.js"></script>`;

		// check if embeded video or not
		setTimeout(function () {
			$(".ft-video-player .box-player").html(embeded == "true" ? embededHTML : videoHTML);
		}, 1000);

		$(".ft-video-player").addClass("show");
		$("body").addClass("overflow-hidden");
	});

	// HIDE: Play Video
	$("body").on("click", ".ft-video-player", function (e) {
		e.preventDefault();

		// Stop Video or Remove Vimeo iframe
		const $videoContainer = $(".ft-video-player .box-player");
		const $iframe = $videoContainer.find("iframe");
		const $video = $videoContainer.find("video");

		if ($iframe.length) {
			// For Vimeo iframe - remove it from the DOM to stop playback
			$iframe.remove();
		} else if ($video.length) {
			// For HTML video - pause the video
			$video.get(0).pause();
		}

		// Hide modal and overlay
		$(".ft-video-player").removeClass("show");
		$("body").removeClass("overflow-hidden");

		// Clear the video container's content (optional cleanup)
		$videoContainer.empty();
	});

	// Scroller
	document.querySelectorAll(".scroller").forEach((scroller) => {
		initializeScroller(scroller);
	});

	// ft-subNav
	document.querySelectorAll(".ft-subNav").forEach((subNavSection) => {
		const subNav = subNavSection.querySelector(".subNav");
		const prevBtn = subNavSection.querySelector(".prevBtn");
		const nextBtn = subNavSection.querySelector(".nextBtn");
		const scrollAmount = 200;

		// Check if subNav, prevBtn, and nextBtn exist to prevent errors
		if (subNav && prevBtn && nextBtn) {
			// Initial button visibility check
			updateButtonVisibility(subNavSection);

			// Event listener for the Next button
			nextBtn.addEventListener("click", () => {
				subNav.scrollBy({ left: scrollAmount, behavior: "smooth" });
			});

			// Event listener for the Previous button
			prevBtn.addEventListener("click", () => {
				subNav.scrollBy({ left: -scrollAmount, behavior: "smooth" });
			});

			// Scroll the active item into view if it exists
			const activeItem = subNav.querySelector(".active");
			if (activeItem) {
				activeItem.scrollIntoView({ inline: "center", behavior: "smooth" });
			}

			// Re-check button visibility on window resize to handle responsive changes
			window.addEventListener("resize", () => updateButtonVisibility(subNavSection));
		}
	});

	// FT Carousel - Select all carousels
	document.querySelectorAll(".ft-carousel").forEach((carousel, index) => {
		const prevButton = carousel.parentElement.querySelector(".btn-prev");
		const nextButton = carousel.parentElement.querySelector(".btn-next");
		const loadingIndicator = carousel.parentElement.querySelector(".carousel-card-loader");

		let scrollTimeout;

		// Set a base scroll offset as a fraction of the carousel's visible width
		const tolerance = 40; // Tolerance for snapping to the edges

		// Function to update button states based on scroll position
		function updateButtonState() {
			const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;

			// Snap to zero if within tolerance range for start
			if (carousel.scrollLeft <= tolerance) {
				carousel.scrollLeft = 0;
			} else if (carousel.scrollLeft >= maxScrollLeft - tolerance) {
				carousel.scrollLeft = maxScrollLeft;
			}

			// Disable previous button if at the start (with tolerance)
			prevButton.disabled = carousel.scrollLeft <= tolerance;

			// Disable next button if at the end (with tolerance)
			nextButton.disabled = carousel.scrollLeft >= maxScrollLeft - tolerance;
		}

		// Debounce function to handle scroll end for snapping (for mouse wheel)
		function debouncedUpdateButtonState() {
			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(updateButtonState, 150); // Adjust debounce delay as needed
		}

		// Button Scroll Functionality
		nextButton.addEventListener("click", () => {
			const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
			const scrollOffset = Math.max(carousel.clientWidth * 0.3, 50);

			// Calculate the remaining distance to the end and scroll by that distance if close
			const offset = Math.min(scrollOffset, maxScrollLeft - carousel.scrollLeft);
			carousel.scrollBy({ left: offset, behavior: "smooth" });

			// Update button state after scroll
			setTimeout(debouncedUpdateButtonState, 300);
		});

		prevButton.addEventListener("click", () => {
			const scrollOffset = Math.max(carousel.clientWidth * 0.3, 50);

			// If close to the start, snap directly to 0, otherwise scroll by offset
			if (carousel.scrollLeft <= scrollOffset + tolerance) {
				carousel.scrollLeft = 0;
				updateButtonState();
			} else {
				// Otherwise, scroll back by the calculated offset
				const offset = Math.min(scrollOffset, carousel.scrollLeft);
				carousel.scrollBy({ left: -offset, behavior: "smooth" });

				// Update button state after scroll
				setTimeout(debouncedUpdateButtonState, 300);
			}
		});

		// Handle scroll events to allow smooth mouse wheel scrolling
		carousel.addEventListener("scroll", debouncedUpdateButtonState);

		// Show carousel and hide loading indicator + buttons after content is loaded
		function showCarousel() {
			if (loadingIndicator) {
				loadingIndicator.classList.add("!hidden"); // Hide the loading indicator
			}
			prevButton.classList.remove("lg:!hidden"); // Show the previous button
			nextButton.classList.remove("lg:!hidden"); // Show the next button
			carousel.classList.remove("!hidden"); // Show the carousel
			updateButtonState();
		}

		// Simulate loading time (remove this in production or replace with actual data loading)
		setTimeout(showCarousel, 1000);

		// Hide buttons during loading
		prevButton.classList.add("lg:!hidden");
		nextButton.classList.add("lg:!hidden");

		// Initial button state update - check if we're at the start or end
		updateButtonState();

		// Disable the previous button on first load
		prevButton.disabled = true;
	});

	// Testimonial
	document.querySelectorAll(".testimonial-container").forEach((container) => {
		const testimonials = container.querySelectorAll(".testimonial-item");
		const bullets = container.parentElement.querySelectorAll(".testimonial-bullet");

		let activeIndex = 0;
		const rotationInterval = 5000;
		let autoRotate;

		function showTestimonial(index) {
			// Hide current testimonial
			testimonials[activeIndex].classList.remove("opacity-100", "block");
			testimonials[activeIndex].classList.add("opacity-0", "hidden");

			// Update active index
			activeIndex = index;

			// Show new testimonial
			testimonials[activeIndex].classList.remove("opacity-0", "hidden");
			testimonials[activeIndex].classList.add("opacity-100", "block");

			// Update bullets
			bullets.forEach((bullet, idx) => {
				bullet.classList.toggle("active", idx === activeIndex);
			});
		}

		// Function to show the next testimonial in the rotation
		function showNextTestimonial() {
			const nextIndex = (activeIndex + 1) % testimonials.length;
			showTestimonial(nextIndex);
		}

		// Start auto-rotation if 'autoplay' class is present
		function startAutoRotate() {
			if (container.classList.contains("autoplay")) {
				autoRotate = setInterval(showNextTestimonial, rotationInterval);
			}
		}

		// Stop auto-rotation
		function stopAutoRotate() {
			clearInterval(autoRotate);
		}

		// Initialize the first testimonial as visible
		showTestimonial(activeIndex);

		// Start auto-rotation if 'autoplay' class is present
		startAutoRotate();

		// Set up bullet click event listeners
		bullets.forEach((bullet, idx) => {
			bullet.addEventListener("click", () => {
				stopAutoRotate();
				showTestimonial(idx);
			});
		});

		// Toggle auto-rotation based on 'autoplay' class presence
		const observer = new MutationObserver(() => {
			if (container.classList.contains("autoplay")) {
				startAutoRotate();
			} else {
				stopAutoRotate();
			}
		});

		// Observe changes to the 'autoplay' class
		observer.observe(container, { attributes: true, attributeFilter: ["class"] });
	});
});

function initializeScroller(scroller) {
	if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		// Set the animation based on data-scrollspeed attribute or fallback to default
		const scrollSpeed = scroller.getAttribute("data-scrollspeed") || 40; // Default to 40s if no data-scrollspeed is set
		scroller.style.setProperty("--animation-duration", `${scrollSpeed}s`);

		scroller.setAttribute("data-animated", true);

		const scrollerInner = scroller.querySelector(".scroller-inner");

		// Remove any existing clones first to prevent duplicating on reload
		Array.from(scrollerInner.children).forEach((item) => {
			if (item.getAttribute("aria-hidden") === "true") {
				item.remove();
			}
		});

		// Clone each item once for continuous scroll effect
		Array.from(scrollerInner.children).forEach((item) => {
			const duplicatedItem = item.cloneNode(true);
			duplicatedItem.setAttribute("aria-hidden", true);
			scrollerInner.appendChild(duplicatedItem);
		});
	}
}

function updateButtonVisibility(subNavSection) {
	const subNav = subNavSection.querySelector(".subNav");
	const prevBtnWrapper = subNavSection.querySelector(".prev-btn-wrapper");
	const nextBtnWrapper = subNavSection.querySelector(".next-btn-wrapper");

	// Check if subNav overflows
	const isOverflowing = subNav.scrollWidth > subNav.clientWidth;

	// Toggle Tailwind classes on the button wrappers based on overflow
	if (isOverflowing) {
		prevBtnWrapper.classList.remove("hidden");
		prevBtnWrapper.classList.add("block");
		nextBtnWrapper.classList.remove("hidden");
		nextBtnWrapper.classList.add("block");
	} else {
		prevBtnWrapper.classList.add("hidden");
		prevBtnWrapper.classList.remove("block");
		nextBtnWrapper.classList.add("hidden");
		nextBtnWrapper.classList.remove("block");
	}
}
